var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 26",
    width: 14,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "baggage-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 26,
    height: 26,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAAXNSR0IB2cksfwAAAIdQTFRFAAAAb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29v35Nr3wAAAC10Uk5TAAHSzNADyc0EVDtc543oWUGK/W6l/6J6FdQZ3MFsw7RPtw3CTuwPRjBHkFqACmgBKgAAAIBJREFUeJxjYIADRiZmZhYGrICVjYGBHbsUx+CWYuXk4ubh5eXjF+BkRZMRFBIWEQUCMXEhQVQ5CUlRmJSopASKlJQ0UEpGVlYOKCUthSklr6CgiEMKauAIkVJSRkgpK6FIMaiowqRUVRjQgBqnugYQaKqoocswMGhpg0huHbgAACR2FbmlLpAHAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "_74468",
    href: "#img1",
    x: -6,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggage);
export default __webpack_public_path__ + "static/media/baggage.6f69d1cb.svg";
export { ForwardRef as ReactComponent };